module.exports = __webpack_public_path__ + "static/media/EVZ.df990bc0.svg";